export const en = {
  'memberImport.open': 'Import',
  'memberImport.back': 'Members',
  'memberImport.title': 'Import members',
  'memberImport.description': "Bring members in from your old system's spreadsheet. Nothing changes until you press Import.",
  'memberImport.step.file': 'File',
  'memberImport.step.columns': 'Columns',
  'memberImport.step.check': 'Check',
  'memberImport.step.done': 'Done',
  'memberImport.file.title': 'Choose a file',
  'memberImport.file.description': 'A CSV or Excel workbook (.xlsx), up to {size} MB and {max} members. The first row names the columns; the first sheet of a workbook is read.',
  'memberImport.file.choose': 'Choose a file',
  'memberImport.file.reading': 'Reading the file…',
  'memberImport.file.needs': 'Each member needs a first name, a last name, and a phone, an email or a card, so a second run of the same file recognises them. Dates read as 31.12.1990 or 1990-12-31.',
  'memberImport.file.tooBig': 'The file is larger than {size} MB.',
  'memberImport.fileError.EMPTY': 'The file has no rows under its header row.',
  'memberImport.fileError.TOO_MANY_ROWS': 'The file has more than {max} rows. Split it and import it in parts.',
  'memberImport.fileError.TOO_LARGE': 'The file is too large to read.',
  'memberImport.fileError.UNSUPPORTED': 'Bulk reads CSV and Excel .xlsx files. Save an old .xls file as .xlsx first.',
  'memberImport.fileError.UNREADABLE': 'The file could not be read. Save it again as CSV or .xlsx and try once more.',
  'memberImport.columns.title': 'Match the columns',
  'memberImport.columns.description': '{file}: {count} rows. Check which column holds each detail; the suggestions come from the column names.',
  'memberImport.columns.notInFile': 'Not in the file',
  'memberImport.columns.unnamed': 'Column {number}',
  'memberImport.columns.example': 'First row: {value}',
  'memberImport.columns.needName': 'Choose the columns with the first and last name.',
  'memberImport.columns.needContact': 'Choose a phone, email or card column, so members can be recognised.',
  'memberImport.columns.membershipNote': 'A plan and an end date bring the membership in too, given without a payment.',
  'memberImport.columns.otherFile': 'Choose another file',
  'memberImport.columns.check': 'Check the rows',
  'memberImport.field.firstName': 'First name',
  'memberImport.field.lastName': 'Last name',
  'memberImport.field.phone': 'Phone',
  'memberImport.field.email': 'Email',
  'memberImport.field.dateOfBirth': 'Date of birth',
  'memberImport.field.cardNumber': 'Card number',
  'memberImport.field.plan': 'Plan',
  'memberImport.field.endDate': 'Membership end date',
  'memberImport.check.title': 'Check before importing',
  'memberImport.check.description': 'This is what the import would do. Rows with problems and people the gym already has are left out.',
  'memberImport.count.new': 'New members',
  'memberImport.count.created': 'Created',
  'memberImport.count.matched': 'Already members',
  'memberImport.count.cardHeld': 'Card held by someone',
  'memberImport.count.invalid': 'Rows with problems',
  'memberImport.memberships.given.one': '{count} member comes in with their membership, given without a payment.',
  'memberImport.memberships.given.other': '{count} members come in with their membership, given without a payment.',
  'memberImport.memberships.leftOut.one': '{count} membership is left out: bringing one in needs the ability to give memberships without a payment.',
  'memberImport.memberships.leftOut.other': '{count} memberships are left out: bringing them in needs the ability to give memberships without a payment.',
  'memberImport.newPlans': 'New hidden plans for plan names the gym does not have: {plans}',
  'memberImport.membershipsDone.given.one': '{count} member came in with their membership, given without a payment.',
  'memberImport.membershipsDone.given.other': '{count} members came in with their memberships, given without a payment.',
  'memberImport.membershipsDone.leftOut.one': '{count} membership was left out: bringing one in needs the ability to give memberships without a payment.',
  'memberImport.membershipsDone.leftOut.other': '{count} memberships were left out: bringing them in needs the ability to give memberships without a payment.',
  'memberImport.newPlansDone': 'New hidden plans were made for plan names the gym did not have: {plans}',
  'memberImport.filter': 'Show',
  'memberImport.filter.ALL': 'All',
  'memberImport.filter.NEW': 'New',
  'memberImport.filter.MATCHED': 'Already members',
  'memberImport.filter.CARD_HELD': 'Card held',
  'memberImport.filter.INVALID': 'Problems',
  'memberImport.col.row': 'Row',
  'memberImport.col.name': 'Name',
  'memberImport.col.outcome': 'Result',
  'memberImport.col.details': 'Details',
  'memberImport.noRows': 'No rows here.',
  'memberImport.outcome.NEW': 'New',
  'memberImport.outcome.CREATED': 'Created',
  'memberImport.outcome.MATCHED': 'Already a member',
  'memberImport.outcome.CARD_HELD': 'Card held',
  'memberImport.outcome.INVALID': 'Problem',
  'memberImport.problem.FIRST_NAME_MISSING': 'No first name',
  'memberImport.problem.LAST_NAME_MISSING': 'No last name',
  'memberImport.problem.NAME_TOO_LONG': 'A name is longer than 80 characters',
  'memberImport.problem.EMAIL_INVALID': 'The email address is not valid',
  'memberImport.problem.PHONE_INVALID': 'The phone number is not valid',
  'memberImport.problem.BIRTH_DATE_INVALID': 'The date of birth cannot be read',
  'memberImport.problem.CARD_INVALID': 'The card number cannot be read; a spreadsheet may have rounded it',
  'memberImport.problem.NOTHING_TO_MATCH': 'No phone, email or card to recognise them by',
  'memberImport.problem.END_DATE_INVALID': 'The end date cannot be read',
  'memberImport.problem.END_DATE_MISSING': 'A plan without an end date',
  'memberImport.problem.PLAN_MISSING': 'An end date without a plan',
  'memberImport.match.EMAIL.member': 'Same email as {name} (#{number})',
  'memberImport.match.EMAIL.line': 'Same email as row {line}',
  'memberImport.match.PHONE.member': 'Same phone as {name} (#{number})',
  'memberImport.match.PHONE.line': 'Same phone as row {line}',
  'memberImport.match.CARD.member': 'Already holds this card: {name} (#{number})',
  'memberImport.match.CARD.line': 'Same person and card as row {line}',
  'memberImport.held.member': 'The card belongs to {name} (#{number})',
  'memberImport.held.line': 'Row {line} has this card for someone else',
  'memberImport.membership.ACTIVE': '{plan} until {date}',
  'memberImport.membership.EXPIRED': '{plan}, ended {date}',
  'memberImport.membership.leftOut': '{plan}: membership left out',
  'memberImport.membership.newPlan': 'new hidden plan',
  'memberImport.backToColumns': 'Back to the columns',
  'memberImport.import.one': 'Import {count} member',
  'memberImport.import.other': 'Import {count} members',
  'memberImport.importing': 'Importing… a large file takes a minute; keep this page open.',
  'memberImport.done.title': 'Import finished',
  'memberImport.done.created.one': '{count} member created',
  'memberImport.done.created.other': '{count} members created',
  'memberImport.done.again': 'The same file can run again: members it already brought in are recognised and nobody is added twice.',
  'memberImport.done.members': 'Go to members',
  'memberImport.done.another': 'Import another file',
};

export const ka: Record<keyof typeof en, string> = {
  'memberImport.open': 'იმპორტი',
  'memberImport.back': 'წევრები',
  'memberImport.title': 'წევრების იმპორტი',
  'memberImport.description': 'გადმოიტანეთ წევრები ძველი სისტემის ცხრილიდან. სანამ „იმპორტს“ არ დააჭერთ, არაფერი შეიცვლება.',
  'memberImport.step.file': 'ფაილი',
  'memberImport.step.columns': 'სვეტები',
  'memberImport.step.check': 'შემოწმება',
  'memberImport.step.done': 'დასრულდა',
  'memberImport.file.title': 'აირჩიეთ ფაილი',
  'memberImport.file.description': 'CSV ან Excel-ის ფაილი (.xlsx), არაუმეტეს {size} მბ-ისა და {max} წევრისა. პირველ სტრიქონში სვეტების სახელებია; Excel-ის ფაილიდან პირველი ფურცელი იკითხება.',
  'memberImport.file.choose': 'აირჩიეთ ფაილი',
  'memberImport.file.reading': 'ფაილი იკითხება…',
  'memberImport.file.needs': 'თითოეულ წევრს სჭირდება სახელი, გვარი და ტელეფონი, ელფოსტა ან ბარათი, რომ იგივე ფაილის ხელახლა გაშვებისას ის ამოიცნოს. თარიღები იკითხება ასე: 31.12.1990 ან 1990-12-31.',
  'memberImport.file.tooBig': 'ფაილი {size} მბ-ზე დიდია.',
  'memberImport.fileError.EMPTY': 'ფაილში სათაურების სტრიქონის ქვემოთ სტრიქონები არ არის.',
  'memberImport.fileError.TOO_MANY_ROWS': 'ფაილში {max}-ზე მეტი სტრიქონია. დაყავით და ნაწილ-ნაწილ შემოიტანეთ.',
  'memberImport.fileError.TOO_LARGE': 'ფაილი წასაკითხად ზედმეტად დიდია.',
  'memberImport.fileError.UNSUPPORTED': 'Bulk კითხულობს CSV და Excel .xlsx ფაილებს. ძველი .xls ფაილი ჯერ .xlsx-ად შეინახეთ.',
  'memberImport.fileError.UNREADABLE': 'ფაილის წაკითხვა ვერ მოხერხდა. თავიდან შეინახეთ CSV ან .xlsx ფორმატში და კიდევ სცადეთ.',
  'memberImport.columns.title': 'შეუსაბამეთ სვეტები',
  'memberImport.columns.description': '{file}: {count} სტრიქონი. შეამოწმეთ, რომელ სვეტშია თითოეული მონაცემი; შეთავაზებები სვეტების სახელებიდანაა.',
  'memberImport.columns.notInFile': 'ფაილში არ არის',
  'memberImport.columns.unnamed': 'სვეტი {number}',
  'memberImport.columns.example': 'პირველი სტრიქონი: {value}',
  'memberImport.columns.needName': 'აირჩიეთ სვეტები სახელითა და გვარით.',
  'memberImport.columns.needContact': 'აირჩიეთ ტელეფონის, ელფოსტის ან ბარათის სვეტი, რომ წევრების ამოცნობა შეიძლებოდეს.',
  'memberImport.columns.membershipNote': 'გეგმა და დასრულების თარიღი აბონემენტსაც შემოიტანს, გადახდის გარეშე გაცემულს.',
  'memberImport.columns.otherFile': 'სხვა ფაილის არჩევა',
  'memberImport.columns.check': 'სტრიქონების შემოწმება',
  'memberImport.field.firstName': 'სახელი',
  'memberImport.field.lastName': 'გვარი',
  'memberImport.field.phone': 'ტელეფონი',
  'memberImport.field.email': 'ელფოსტა',
  'memberImport.field.dateOfBirth': 'დაბადების თარიღი',
  'memberImport.field.cardNumber': 'ბარათის ნომერი',
  'memberImport.field.plan': 'გეგმა',
  'memberImport.field.endDate': 'აბონემენტის დასრულების თარიღი',
  'memberImport.check.title': 'შეამოწმეთ იმპორტამდე',
  'memberImport.check.description': 'ასე ჩატარდება იმპორტი. პრობლემური სტრიქონები და ის ადამიანები, ვინც დარბაზს უკვე ჰყავს, არ შემოვა.',
  'memberImport.count.new': 'ახალი წევრები',
  'memberImport.count.created': 'შექმნილი',
  'memberImport.count.matched': 'უკვე წევრები არიან',
  'memberImport.count.cardHeld': 'ბარათი სხვას ეკუთვნის',
  'memberImport.count.invalid': 'პრობლემური სტრიქონები',
  'memberImport.memberships.given.one': '{count} წევრი შემოვა თავისი აბონემენტით, გადახდის გარეშე გაცემულით.',
  'memberImport.memberships.given.other': '{count} წევრი შემოვა თავისი აბონემენტით, გადახდის გარეშე გაცემულით.',
  'memberImport.memberships.leftOut.one': '{count} აბონემენტი არ შემოვა: ამისთვის საჭიროა აბონემენტის გადახდის გარეშე გაცემის უფლება.',
  'memberImport.memberships.leftOut.other': '{count} აბონემენტი არ შემოვა: ამისთვის საჭიროა აბონემენტის გადახდის გარეშე გაცემის უფლება.',
  'memberImport.newPlans': 'ახალი დამალული გეგმები იმ სახელებისთვის, რომლებიც დარბაზს არ აქვს: {plans}',
  'memberImport.membershipsDone.given.one': '{count} წევრი შემოვიდა თავისი აბონემენტით, გადახდის გარეშე გაცემულით.',
  'memberImport.membershipsDone.given.other': '{count} წევრი შემოვიდა თავისი აბონემენტით, გადახდის გარეშე გაცემულით.',
  'memberImport.membershipsDone.leftOut.one': '{count} აბონემენტი არ შემოვიდა: ამისთვის საჭიროა აბონემენტის გადახდის გარეშე გაცემის უფლება.',
  'memberImport.membershipsDone.leftOut.other': '{count} აბონემენტი არ შემოვიდა: ამისთვის საჭიროა აბონემენტის გადახდის გარეშე გაცემის უფლება.',
  'memberImport.newPlansDone': 'შეიქმნა ახალი დამალული გეგმები იმ სახელებისთვის, რომლებიც დარბაზს არ ჰქონდა: {plans}',
  'memberImport.filter': 'ჩვენება',
  'memberImport.filter.ALL': 'ყველა',
  'memberImport.filter.NEW': 'ახალი',
  'memberImport.filter.MATCHED': 'უკვე წევრები',
  'memberImport.filter.CARD_HELD': 'ბარათი დაკავებულია',
  'memberImport.filter.INVALID': 'პრობლემები',
  'memberImport.col.row': 'სტრიქონი',
  'memberImport.col.name': 'სახელი',
  'memberImport.col.outcome': 'შედეგი',
  'memberImport.col.details': 'დეტალები',
  'memberImport.noRows': 'აქ სტრიქონები არ არის.',
  'memberImport.outcome.NEW': 'ახალი',
  'memberImport.outcome.CREATED': 'შეიქმნა',
  'memberImport.outcome.MATCHED': 'უკვე წევრია',
  'memberImport.outcome.CARD_HELD': 'ბარათი დაკავებულია',
  'memberImport.outcome.INVALID': 'პრობლემა',
  'memberImport.problem.FIRST_NAME_MISSING': 'სახელი არ არის',
  'memberImport.problem.LAST_NAME_MISSING': 'გვარი არ არის',
  'memberImport.problem.NAME_TOO_LONG': 'სახელი ან გვარი 80 სიმბოლოზე გრძელია',
  'memberImport.problem.EMAIL_INVALID': 'ელფოსტის მისამართი არასწორია',
  'memberImport.problem.PHONE_INVALID': 'ტელეფონის ნომერი არასწორია',
  'memberImport.problem.BIRTH_DATE_INVALID': 'დაბადების თარიღი ვერ იკითხება',
  'memberImport.problem.CARD_INVALID': 'ბარათის ნომერი ვერ იკითხება; შესაძლოა, ცხრილმა დაამრგვალა',
  'memberImport.problem.NOTHING_TO_MATCH': 'არ არის ტელეფონი, ელფოსტა ან ბარათი, რომლითაც მისი ამოცნობა შეიძლება',
  'memberImport.problem.END_DATE_INVALID': 'დასრულების თარიღი ვერ იკითხება',
  'memberImport.problem.END_DATE_MISSING': 'გეგმა დასრულების თარიღის გარეშე',
  'memberImport.problem.PLAN_MISSING': 'დასრულების თარიღი გეგმის გარეშე',
  'memberImport.match.EMAIL.member': 'ელფოსტა ემთხვევა: {name} (#{number})',
  'memberImport.match.EMAIL.line': 'ელფოსტა ემთხვევა მე-{line} სტრიქონს',
  'memberImport.match.PHONE.member': 'ტელეფონი ემთხვევა: {name} (#{number})',
  'memberImport.match.PHONE.line': 'ტელეფონი ემთხვევა მე-{line} სტრიქონს',
  'memberImport.match.CARD.member': 'ეს ბარათი უკვე აქვს: {name} (#{number})',
  'memberImport.match.CARD.line': 'იგივე ადამიანი და ბარათი, რაც მე-{line} სტრიქონში',
  'memberImport.held.member': 'ბარათი ეკუთვნის: {name} (#{number})',
  'memberImport.held.line': 'ეს ბარათი მე-{line} სტრიქონში სხვა ადამიანს აქვს',
  'memberImport.membership.ACTIVE': '{plan}, {date}-მდე',
  'memberImport.membership.EXPIRED': '{plan}, დასრულდა {date}',
  'memberImport.membership.leftOut': '{plan}: აბონემენტი არ შემოვა',
  'memberImport.membership.newPlan': 'ახალი დამალული გეგმა',
  'memberImport.backToColumns': 'სვეტებზე დაბრუნება',
  'memberImport.import.one': '{count} წევრის იმპორტი',
  'memberImport.import.other': '{count} წევრის იმპორტი',
  'memberImport.importing': 'მიმდინარეობს იმპორტი… დიდ ფაილს ერთი წუთი სჭირდება; ნუ დახურავთ გვერდს.',
  'memberImport.done.title': 'იმპორტი დასრულდა',
  'memberImport.done.created.one': 'შეიქმნა {count} წევრი',
  'memberImport.done.created.other': 'შეიქმნა {count} წევრი',
  'memberImport.done.again': 'იგივე ფაილის ხელახლა გაშვება შეიძლება: უკვე შემოტანილ წევრებს ამოიცნობს და ორჯერ არავის დაამატებს.',
  'memberImport.done.members': 'წევრებზე გადასვლა',
  'memberImport.done.another': 'სხვა ფაილის იმპორტი',
};
